import React, { useState } from "react";
import Header from "../components/header";
import SidebarHeader from "../components/sidebarHeader";
import { useMediaQuery } from "react-responsive";
import Footer from "../components/Footer";
import { useSelector } from "react-redux"; // For language selection

const TermsOfUse = () => {
  const [menu, setMenu] = useState("");
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1150px)" });
  const isLang = useSelector((state) => state.authReducer.lang);

  const handleMouseOver = (type) => {
    setMenu(type);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <Header menu={menu} setMenu={setMenu} />
      ) : (
        <SidebarHeader />
      )}
      <div
        onMouseOver={() => handleMouseOver("")}
        className={`text-black ${isLang === "arabic" ? "rtl" : "ltr"}`}
      >
        <section className="w-full bg-gradient-to-r mt-10 from-purple-100 to-blue-50 min-h-screen py-10">
          <div className="container mx-auto max-w-6xl px-6">
            <div className="text-center mb-8">
            <p
              className="font-[700] text-[26px] md:text-[32px] flex items-center justify-center bg-gradient-to-r from-purple-700 to-purple-800 lg:text-[32px] text-center py-20"
              style={{
                fontFamily: "poppins",
                height: "250px",
                color: "#FFF",
              
              }}
            >
          {isLang === "eng" ? "Terms of Use" : "شروط الاستخدام"}
            </p>
             
            </div>

            {/* Section 1 */}
            <div className="bg-white shadow-2xl rounded-lg p-10">
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Introduction" : "مقدمة"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Before using any Maker4U services, you must read, understand, and accept this agreement by selecting "I do agree." Agree to these terms and conditions only if you've read and accept them. And if you can't accept everything in this policy, kindly don't use our products and services.`
                  : `قبل استخدام أي من خدمات Maker4U، يجب عليك قراءة هذه الاتفاقية وفهمها وقبولها من خلال تحديد "أوافق". لا توافق على هذه الشروط والأحكام إلا إذا قرأتها وقبلتها. وإذا لم تتمكن من قبول كل ما هو وارد في هذه السياسة، يرجى عدم استخدام منتجاتنا وخدماتنا.`
                }
              </p>
              {/* section 2 */}
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `These terms contain the rules for your dealings with "Maker4U". The Company reserves the right to change or suspend any of the Terms of Service without prior notice or giving a reason. The company will not be liable if they discontinue, change, or pause the services. You agree to such terms. Another one, study Maker4U's Privacy Policy to understand your private info. Additionally, the Company can modify the Terms of Service, so you need to recheck it from time to time to see if anything has changed.`
                  : `تحتوي هذه الشروط على قواعد تعاملاتك مع "Maker4U". تحتفظ الشركة بالحق في تغيير أو تعليق أي من شروط الخدمة دون إشعار مسبق أو إبداء سبب. لن تكون الشركة مسؤولة إذا أوقفت أو غيرت أو أوقفت الخدمات مؤقتًا. أنت توافق على هذه الشروط. أيضاً، قم بدراسة سياسة الخصوصية الخاصة بـ Maker4U لفهم معلوماتك الخاصة. بالإضافة إلى ذلك، يمكن للشركة تعديل شروط الخدمة، لذلك تحتاج إلى إعادة التحقق منها من وقت لآخر لمعرفة ما إذا كان هناك أي تغيير.`
                }
              </p>
              {/* section 3 */}
              <h2
  className={`text-3xl font-semibold ${
    isLang === "arabic" ? "text-right" : "text-left"
  }`}
>
  {isLang === "eng" ? "Here are some important definitions" : "فيما يلي بعض التعريفات المهمة"}
</h2>

<div
  className={`text-lg ${
    isLang === "arabic" ? "text-right" : "text-left"
  } mt-4`}
>
  {isLang === "eng" ? (
    <>
      <p>- Maker4U Service: In other words, Maker4U provides users with services that are in the form of their website, web app, and mobile app.</p>
      <p>- Service: Generally-serving refers to the services on Maker4U's worldwide web site.</p>
      <p>- "User" or "you": On the other hand, the Maker4U Service’s users can either sign up or not.</p>
      <p>- Content: The contents of anything such as images, text, videos, etc., that users upload or create through using the Maker4U Service.</p>
      <p>- Maker4U Design Templates: Materials the user gets to use in the design of the product they can access from Maker4U.</p>
      <p>- Creative Images: Websites of Maker4U contain graphics available for direct use on designs by users.</p>
      <p>- Paid Service: Subscription-based services and features that you will have to pay for.</p>
      <p>- Subscription: Regular payment to have access to Maker4U's pay-for-use service.</p>
      <p>- Design Project: A design work in due time as it appears on the Maker4U website.</p>
      <p>- Final Work: A design that you finished using Maker4U.</p>
      <p>- Commercial Use of Final Work: Creating a business or marketing communication using your finished artwork.</p>
      <p>- Personal Use of Final Work: Using your finished design for personal, non-profit reasons.</p>
    </>
  ) : (
    <div dir="rtl">
      <p>- خدمة Maker4U: بمعنى آخر، توفر Maker4U للمستخدمين خدمات في شكل موقع ويب وتطبيق ويب وتطبيق جوال.</p>
      <p>- الخدمة: بشكل عام، تشير الخدمة إلى الخدمات المقدمة على موقع Maker4U على شبكة الإنترنت في جميع أنحاء العالم.</p>
      <p>- "المستخدم" أو "أنت": يمكن لمستخدمي خدمة Maker4U التسجيل أو لا.</p>
      <p>- المحتوى: محتويات أي شيء مثل الصور والنصوص ومقاطع الفيديو وما إلى ذلك، التي يقوم المستخدمون بتحميلها أو إنشائها من خلال استخدام خدمة Maker4U.</p>
      <p>- نماذج تصميم Maker4U: المواد التي يمكن للمستخدم استخدامها في تصميم المنتج الذي يمكنه الوصول إليه من Maker4U.</p>
      <p>- الصور الإبداعية: تحتوي مواقع Maker4U على رسومات متاحة للاستخدام المباشر في التصميمات من قبل المستخدمين.</p>
      <p>- الخدمة المدفوعة: خدمات وميزات تعتمد على الاشتراك والتي سيتعين عليك الدفع مقابلها.</p>
      <p>- الاشتراك: الدفع المتكرر للحصول على إمكانية الوصول إلى خدمة الدفع مقابل الاستخدام الخاصة بـ Maker4U.</p>
      <p>- مشروع التصميم: عمل تصميم في الوقت المناسب كما يظهر على موقع Maker4U.</p>
      <p>- العمل النهائي: التصميم الذي انتهيت منه باستخدام Maker4U.</p>
      <p>- الاستخدام التجاري للعمل النهائي: إنشاء اتصال تجاري أو تسويقي باستخدام عملك الفني المستقبلي.</p>
      <p>- الاستخدام الشخصي للعمل النهائي: استخدام التصميم النهائي لأسباب شخصية غير ربحية.</p>
    </div>
  )}
</div>

              {/* section 4 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Account and content guidelines" : "إرشادات الحساب والمحتوى"}
              </h2>
              <div
  className={`text-lg ${
    isLang === "arabic" ? "text-right" : "text-left"
  } mt-4`}
>
  {isLang === "eng" ? (
    <>
      <p>- The first step you take is to create an account with Maker4U and fill in your email and password.</p>
      <p>- As laws may vary from one jurisdiction to another, you may need to do so as required by the local laws.</p>
      <p>- Keep your account safe and use a unique password. Avoid sharing it with other people.</p>
      <p>- Don't use your account to perform operations that do not involve compensation.</p>
      <p>- In case you think that the details are provided to the Maker4U team by someone else without your approval, let Maker4U know about it.</p>
    </>
  ) : (
    <div dir="rtl">
      <p >-الخطوة الأولى التي يجب عليك اتخاذها هي إنشاء حساب مع Maker4U وإدخال بريدك الإلكتروني وكلمة المرور</p>
      <p>-نظرًا لأن القوانين قد تختلف من ولاية قضائية إلى أخرى، فقد يتعين عليك القيام بذلك وفقًا لما تقتضيه القوانين المحلية</p>
      <p>-حافظ على أمان حسابك واستخدم كلمة مرور فريدة وتجنب مشاركتها مع الآخرين</p>
      <p>-لا تستخدم حسابك لإجراء عمليات لا تتضمن التعويضات</p>
      <p>-في حال كنت تعتقد أن التفاصيل تم تقديمها لفريق Maker4U من قبل شخص آخر دون موافقتك، فأخبر Maker4U بذلك</p>
    </div>
  )}
</div>

              {/* section 5 */}
              <h2
  className={`text-3xl font-semibold ${
    isLang === "arabic" ? "text-right" : "text-left"
  }`}
>
  {isLang === "eng" ? "Be mindful of the content you upload" : "كن حذرًا بشأن المحتوى الذي تقوم بتحميله:"}
</h2>
<div
  className={`text-lg ${
    isLang === "arabic" ? "text-right" : "text-left"
  } mt-4`}
>
  {isLang === "eng" ? (
    <>
      <p>- Keeping the rules and protecting people's rights.</p>
      <p>- Keep away from the posting of nasty or offensive content.</p>
      <p>- Do not put copyrighted material unless you have a copyright.</p>
      <p>- Maker4U can take down content if it is against these guidelines.</p>
    </>
  ) : (
    <div dir="rtl">
      <p>-الالتزام بالقواعد وحماية حقوق الناس.</p>
      <p>-الابتعاد عن نشر المحتوى القذر أو المسيء.</p>
      <p>- لا تضع مواد محمية بحقوق الطبع والنشر إلا إذا كان لديك حقوق الطبع والنشر.</p>
      <p>-يمكن لـ Maker4U إزالة المحتوى الذي يتعارض مع هذه الإرشادات.</p>
    </div>
  )}
</div>
              {/* section 6 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "If you think someone's infringing on your rights" : "إذا كنت تعتقد أن شخصًا ما ينتهك حقوقك"}
              </h2>
              <div
  className={`text-lg ${
    isLang === "arabic" ? "text-right" : "text-left"
  } mt-4`}
>
  {isLang === "eng" ? (
    <>
      <p>- Fill out the attached form that will provide the necessary details and proof.</p>
      <p>- Maker4U will do its homework and apply immediate remedial measures.</p>
    </>
  ) : (
    <div dir="rtl">
      <p>-قم بتعبئة النموذج المرفق والذي سيتضمن التفاصيل والإثباتات اللازمة.</p>
      <p>-سوف يقوم Maker4U بأداء واجباته وتطبيق التدابير التصحيحية الفورية.</p>
    </div>
  )}
</div>

              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `We've just touched the surface of what you should be aware of before you utilize Maker 4 U's services!`
                  : `لقد لامسنا للتو سطح ما يجب أن تكون على علم به قبل الاستفادة من خدمات Maker 4 U!`
                }
              </p>
              {/* section 7 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Maker4U's Intellectual Property Rights" : "حقوق الملكية الفكرية لـ Maker4U"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `In addition, Maker4U holds the software and all other tools (like images, webpages, as well as text) needed for the service provision. Such rights are protected by copyright laws. Without Maker4U's permission, you can't present the service's information, implement it, or create it from the service. You are not allowed to duplicate or be connected to any part of the service without asking. You do not have to copy or use Maker4U's service for business elsewhere. Maker4U authorizes access to the service on only one device with the understanding that you won’t be trying to discover the system’s source code or backdooring your way into the service.`
                  : `بالإضافة إلى ما سبق، تحتفظ Maker4U بالبرنامج وجميع الأدوات الأخرى (مثل الصور وصفحات الويب والنصوص) اللازمة لتقديم الخدمة. وتخضع هذه الحقوق لحماية قوانين حقوق النشر. وبدون إذن من Maker4U، لا يمكنك تقديم معلومات الخدمة أو تطبيقها أو إنشائها من الخدمة. ولا يجوز لك نسخ أي جزء من الخدمة أو الوصل بها دون إذن. ولا يتعين عليك نسخ أو استخدام خدمة Maker4U لأغراض تجارية في مكان آخر. وتسمح Maker4U بالوصول إلى الخدمة على جهاز واحد فقط مع العلم أنك لن تحاول اكتشاف الكود المصدر للنظام أو اختراق الخدمة.`
                }
              </p>
              {/* section 8 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Maker4U's Design Templates" : "نماذج التصميم الخاصة بـ Maker4U"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `In the absence of information to the contrary, those appearing on Maker4U's Design Templates are copyrighted by Maker4U. Depending on your type of subscription, the templates may be different in the terms you can use them for commercial or personal purposes.`
                  : `في حالة عدم وجود معلومات على عكس ذلك، فإن المواد التي تظهر على نماذج التصميم الخاصة بـ Maker4U محمية بحقوق الطبع والنشر الخاصة  بـ .Maker4U اعتمادًا على نوع اشتراكك، قد تختلف القوالب في الشروط التي يمكنك استخدامها لأغراض تجارية أو شخصية.`
                }
              </p>
              {/* section 9 */}
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Commercial Use: In the case of a Design Resources Pro+ subscription, they can also be utilized for commercial purposes during the subscription period. One of the main reasons to purchase a Pro account is basically to take advantage of Design Resources as a Pro user. Design Resources can be utilized for commercial purposes, except for some that are designated for Pro+ users. They are the ones that your service cannot utilize for the provision of services for Maker4U.`
                  : `الاستخدام التجاري: في حالة الاشتراك في Design Resources Pro+، يمكن أيضًا الاستفادة منها لأغراض تجارية أثناء فترة الاشتراك. أحد الأسباب الرئيسية لشراء حساب Pro هو الاستفادة من Design Resources كمستخدم Pro. يمكن استخدام  Design Resources  لأغراض تجارية، باستثناء بعض الموارد المخصصة لمستخدمي Pro+. وهي الموارد التي لا تستطيع خدمتك الاستفادة منها لتقديم الخدمات لـ Maker4U.`
                }
              </p>
              {/* section 10 */}
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Personal Use: The complimentary users have the right to use the Design Resources only for particular needs, for example, to design a new greeting card or "wallpaper". Free users have the privilege to use the Design Resources only for personal use.`
                  : `الاستخدام الشخصي: يحق للمستخدمين المجانيين استخدام موارد التصميم فقط لاحتياجات معينة، على سبيل المثال، لتصميم بطاقة تهنئة جديدة أو "خلفية". يتمتع المستخدمون المجانيون بامتياز استخدام موارد التصميم فقط للاستخدام الشخصي.`
                }
              </p>
              {/* section 11 */}
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Client Work: Maker4U's resources, if clients are using them, must keep a separate account and must follow the terms set by Maker4U.`
                  : `عمل العميل: اذا كان العملاء يستخدمون موارد Maker4U، يجب عليهم أبقاء حساب منفصل ويجب أن تتبع الشروط التي وضعها Maker4U.`
                }
              </p>
              {/* section 12 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Third-Party Intellectual Property" : "الملكية الفكرية لطرف ثالث"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Images, video, audio, and fonts that feature are from third parties for illustration purposes only. You get to copy them from the copyright owner but use them in another work.`
                  : `الصور والفيديوهات والمقاطع الصوتية والخطوط المعروضة من جهات طرف ثالث لأغراض توضيحية. يمكنك نسخها من مالك حقوق الطبع والنشر ولكن يمكنك استخدامها في عمل آخر.`
                }
              </p>
              {/* section 13 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Billing for Paid Service" : "الفواتير الخاصة بالخدمات المدفوعة"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Subscriptions, which are paid in advance and non-refundable, are due in a month. Other options comprise credits for different services which are purchased, but cannot be refunded.`
                  : `الاشتراكات التي يتم دفعها مقدمًا وغير قابلة للاسترداد، تستحق في غضون شهر. تتضمن الخيارات الأخرى أرصدة لخدمات مختلفة يتم شراؤها، ولكن لا يمكن استردادها.`
                }
              </p>
              {/* section 14 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Printing Service" : "خدمة الطباعة"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Maker4U is not the printing service provider but works with partners to offer print services. Moreover, any printing issue remains the responsibility of the partner and not Maker4U.`
                  : `لا تعد Maker4U شركة تقدم خدمات الطباعة ولكنها تعمل مع الشركاء لتقديم خدمات الطباعة. علاوة على ذلك، تظل أي مشكلة تتعلق بالطباعة مسؤولية الشريك وليس Maker4U.`
                }
              </p>
              {/* section 15 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Promotional Offers" : "العروض الترويجية"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Maker4U gives a ticket back on the promotion, but cannot guarantee a refund if any form of payment was made during the promotion.`
                  : `يقدم Maker4U تذكرة إرجاع في العرض الترويجي، ولكن لا يمكن ضمان استرداد الأموال إذا تم إجراء أي شكل من أشكال الدفع أثناء العرض الترويجي.`
                }
              </p>
              {/* section 16 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Invoicing" : "الفواتير"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Billing will be the next step after which Maker4U will issue invoices for payments. You would be required to communicate the appropriate billing information with the customer.`
                  : `ستكون عملية الفوترة هي الخطوة التالية التي ستصدر بعدها Maker4U فواتير الدفع. سيُطلب منك توصيل معلومات الفوترة المناسبة للعميل.`
                }
              </p>
              {/* section 17 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Jurisdiction/ Confliction of Laws & Dispute Resolution" : "الاختصاص القضائي/ تضارب القوانين وحل النزاعات"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `Whether in mainland China or international disputes, our company is subject to Chinese laws. The settlement of the disputes is through lawsuits. You don't participate in a class-action lawsuit any longer.`
                  : `سواء في الصين أو في نزاعات دولية، تخضع شركتنا للقوانين الصينية. تتم تسوية النزاعات من خلال الدعاوى القضائية. لم تعد (انت) تشارك في دعوى قضائية جماعية.`
                }
              </p>
              {/* section 18 */}
              <h2
                className={`text-3xl font-semibold ${
                  isLang === "arabic" ? "text-right" : "text-left"
                }`}
              >
                {isLang === "eng" ? "Contact Us" : "أتصل بنا"}
              </h2>
              <p
                className={`text-lg ${
                  isLang === "arabic" ? "text-right" : "text-left"
                } mt-4`}
              >
                {isLang === "eng"
                  ? `If you have any questions regarding these Terms of Use, please contact us at [email protected] or visit our FAQ page at [link to FAQ page].`
                  : `إذا كانت لديك أي أسئلة بخصوص شروط الاستخدام هذه، يرجى الاتصال بنا على [email protected] أو قم بزيارة صفحة الأسئلة الشائعة على [link to FAQ page].`
                }
              </p>
            </div>
            </div>

            
          
        </section>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfUse;
